(function(){
    angular
        .module('appback')
        .directive('ngHemograma', hemograma);

        hemograma.$inject = ['GenerallabService','$uibModal','ResultadosService','$timeout'];
        function hemograma(GenerallabService,$uibModal,ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=hemograma.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  peticion:'=',
                  categoria:'=',
                  centro:'='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {


                  scope.generalLab = GenerallabService;
                  scope.loading = true;
                  scope.dilucionModal = "";
                  //console.log("hem",scope.item.resultado.extra.resultado);
                  if(!scope.item.resultado){
                      scope.item.resultado = { extra : { resultado : { subanalitica : { created:''}, config : {dilucion:1} }}};
                  }else{
                    if(!scope.item.resultado.extra){
                      scope.item.resultado.extra = { resultado : {subanalitica : { created:''}, config : {dilucion:1} }};
                    }else{
                      if(!scope.item.resultado.extra.resultado){
                        scope.item.resultado.extra.resultado = { subanalitica : { created:''}, config : {dilucion:1}};
                      }else{
                        if(Array.isArray(scope.item.resultado.extra.resultado)){
                          scope.item.resultado.extra.resultado = { subanalitica : { created:''}, config : {dilucion:1}};
                        }else{
                          if(!scope.item.resultado.extra.resultado.config){
                            scope.item.resultado.extra.resultado.config = { dilucion : 1};
                          }
                        }
                       //console.log("resmd");
                       //console.log(scope.item.resultado.extra.resultado);

                      }
                    }
                }
                 
		            	//console.log(scope);
		            	scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,scope.centro.idioma_code,function(data){
                    scope.loading = false;
			               scope.subanaliticas = data.subanaliticas;
                     for(var cont=0;cont<scope.subanaliticas.length;cont++){
                       if(typeof(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa])=='undefined'){
                         scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa] = { resultado : '',valornormalidad:'',unidad:'',nombre:''};
                         
                       }else{
                        if(angular.isDefined(data.subanaliticas[cont].valoresnormalidad)){
                          scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].valoresnormalidad = data.subanaliticas[cont].valoresnormalidad.valor;
                        }
                        if(angular.isDefined(data.subanaliticas[cont].unidad)){
                          scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].unidad = data.subanaliticas[cont].unidad.nombre;
                        }
                        scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].nombre = data.subanaliticas[cont].nombre;
                       }
                       //console.log("EEASDASD",scope.item.resultado.extra.resultado.subanalitica);
                       scope.subanaliticas[cont].resultado = scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa];
                       
                       scope.generalLab.setInterpretacionesSubanalitica(scope.item,scope.subanaliticas[cont]);
                     }
                     scope.generalLab.getInterpretacionesCategoria(scope.peticion,scope.categoria);

			            });

                  scope.codesCambiar = ['RBC','HGB','HCT','HGBCEL','RETIC','PLT','WBC','LIM','MON','BAS','EOS','NEU','LUC'];

                  scope.hayResultados = function(dil){
                    var res = false;
                    for(var cont = 0; cont< scope.codesCambiar.length && !res;cont++){
                      if(typeof(scope.item.resultado.extra.resultado.subanalitica)!='undefined' && typeof(scope.item.resultado.extra.resultado.subanalitica[scope.codesCambiar[cont]]) !='undefined' && !isNaN(scope.item.resultado.extra.resultado.subanalitica[scope.codesCambiar[cont]].resultado)){
                        res = true;
                      }
                    }
                    return res;
                  }
                  scope.cambiarResultados = function(dil){
                    for(var cont = 0; cont< scope.codesCambiar.length;cont++){
                      if(typeof(scope.item.resultado.extra.resultado.subanalitica[scope.codesCambiar[cont]]) !='undefined' && !isNaN(scope.item.resultado.extra.resultado.subanalitica[scope.codesCambiar[cont]].resultado)){
                        scope.item.resultado.extra.resultado.subanalitica[scope.codesCambiar[cont]].resultado = ((scope.item.resultado.extra.resultado.subanalitica[scope.codesCambiar[cont]].resultado/scope.item.resultado.extra.resultado.config.dilucion)*dil).toFixed(2);
                      }
                    }
                  }
                  scope.cambiarDilucion = function(dil){

                    if(scope.hayResultados()){
                       scope.dilucionModal = $uibModal.open({
                        animation: true,
                        ariaLabelledBy: 'modal-title-top',
                        ariaDescribedBy: 'modal-body-top',
                        //windowClass: 'modal-danger',
                        backdrop  : 'static',
                        templateUrl: 'cambiarres.html',

                        //size: 'xlg',
                        controller: function($scope) {
                            $scope.okForm = function(){
                              if(dil!=scope.item.resultado.extra.resultado.config.dilucion){
                                scope.cambiarResultados(dil);
                              }
                              scope.item.resultado.extra.resultado.config.dilucion = dil;
                              scope.dilucionModal.close();
                            }
                            $scope.koForm = function(){
                                scope.item.resultado.extra.resultado.config.dilucion = dil;
                                scope.dilucionModal.close();
                            }
                        }
                      });
                     }else{
                      scope.item.resultado.extra.resultado.config.dilucion = dil;
                     }
                    
                  }

                  scope.contienePorcentaje = function(subanalitica){
                    var resultado = false;
                    for(var cont=0;cont<scope.subanaliticas.length && !resultado;cont++){
                      if(scope.subanaliticas[cont].subanalitica_id==subanalitica.id){
                        resultado = scope.subanaliticas[cont];
                      }
                    }
                    return resultado;
                  }

                  scope.calcularMediaPlaquetas = function(){
                    var contadorMedia = 0;
                    var contadorRes = 0;
                    if(typeof(scope.item.resultado.extra.recuento_plaquetas)=='undefined'){
                      return false;
                    }
                    for (var [key, value] of Object.entries(scope.item.resultado.extra.recuento_plaquetas.plaquetas)) {
                      if(scope.item.resultado.extra.recuento_plaquetas.plaquetas[key]){
                        contadorRes+=parseInt(scope.item.resultado.extra.recuento_plaquetas.plaquetas[key]);
                        contadorMedia++;
                      }
                    }
                    return (contadorRes/contadorMedia).toFixed(2);
                  }

                  scope.sumaBloque = function(bloque){
                    var suma = 0;
                    for( var cont=0;cont<scope.subanaliticas.length;cont++){
                      if(scope.subanaliticas[cont].bloque==bloque){
                        if(typeof(scope.item.resultado.extra.resultado.subanalitica) != 'undefined' && typeof(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa]) != 'undefined'){
                          suma += parseInt(scope.calcularPer(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa]));
                        }
                      }
                    }
                    return suma;
                  }
                  scope.contienePe = function(subanalitica){
                    var resultado = false;
                    var nombreSub = subanalitica.codigo_alfa.toLowerCase();
                    if(nombreSub.includes("_p")){
                      resultado = true;
                    }
                    return resultado;
                  }

                  scope.calcularPer = function(resultado){
                    if(!resultado){
                      return "-";
                    }
                    return  Math.round((resultado.resultado*100)/scope.item.resultado.extra.resultado.subanalitica['WBC'].resultado);
                  }

                  scope.valorNormalidad = function(subanalitica){
                    var resultado = false;
                    //console.log(scope.item.resultado);
                    if(typeof(scope.item.resultado) !='undefined' && typeof(subanalitica.valoresnormalidad)!='undefined'){
                      if(typeof(subanalitica.valoresnormalidad.valor)!='undefined'){
                        var valorNormalidad = subanalitica.valoresnormalidad.valor.split("-");
                        if(typeof(scope.item.resultado.extra)!='undefined' && scope.item.resultado.extra && typeof(scope.item.resultado.extra.resultado.subanalitica) != 'undefined' && typeof(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa]) != 'undefined'){
                          if(parseFloat(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa].resultado)<parseFloat(valorNormalidad[0].replace(/,/g,'.').trim())){
                            resultado = -1;
                          }else{
                             if(parseFloat(scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa].resultado)>parseFloat(valorNormalidad[1].replace(/,/g,'.').trim())){
                                // console.log(parseFloat(subanalitica.resultado.resultado));
                                 //console.log(parseFloat(valorNormalidad[1].trim()));
                                 resultado = 1;
                             }
                          }
                        }
                      }
                    }
                    return resultado;
                            
                  }

			        });
		        }
          }
      }
})();